import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserContext } from '../../context/user';

interface AuthRouteProps {
    children: React.ReactNode;
}

const AuthRoute: React.FC<AuthRouteProps> = ({ children }) => {
    const { jwtToken } = useUserContext();

    if (jwtToken) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default AuthRoute;
